import request from 'superagent'
import types from '../types'
import NewsUpdates from '../../types/NewsUpdates'
import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let api_url = `${protocol}//${hostname}:${api_port}/api`

if (api_port === '') {
    api_url = `${protocol}//${hostname}/api`
}

export const getNewsAndUpdates = (id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(getNewsAndUpdatesRequested())
    request
      .get(`${api_url}/newsupdates/${id}`)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .then((response) => {
        dispatch(getNewsAndUpdatesFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getNewsAndUpdatesRejected(error))
      })
  }
}

const getNewsAndUpdatesRequested = () => ({
    type: types.GET_NEWS_UPDATES_REQUESTED,
    payload: null
})

const getNewsAndUpdatesFulfilled = (data: Array<NewsUpdates>) => ({
    type: types.GET_NEWS_UPDATES_FULFILLED,
    payload: data
})

const getNewsAndUpdatesRejected = (error: any) => ({
    type: types.GET_NEWS_UPDATES_REJECTED,
    payload: error
})

export const getAnnouncement = (token: string) => {
  return (dispatch: any) => {
    dispatch(getAnnouncementRequested())
    request
      .get(`${api_url}/announcement`)
      .set('access-token',token)
      .set('Accept', 'application/json')
      .then((response) => {
        dispatch(getAnnouncementFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getAnnouncementRejected(error))
      })
  }
}

const getAnnouncementRequested = () => ({
    type: types.GET_ANNOUNCEMENT_REQUESTED,
    payload: null
})

const getAnnouncementFulfilled = (data: Array<NewsUpdates>) => ({
    type: types.GET_ANNOUNCEMENT_FULFILLED,
    payload: data
})

const getAnnouncementRejected = (error: any) => ({
    type: types.GET_ANNOUNCEMENT_REJECTED,
    payload: error
})

export const getNewsAndUpdatesByOrganization = (id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(getNewsAndUpdatesByOrganizationRequested())
    request
      .get(`${api_url}/newsupdates/organization/${id}`)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .then((response) => {
        dispatch(getNewsAndUpdatesByOrganizationFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getNewsAndUpdatesByOrganizationRejected(error))
      })
  }
}

const getNewsAndUpdatesByOrganizationRequested = () => ({
    type: types.GET_NEWS_UPDATES_BY_ORGANIZATION_REQUESTED,
    payload: null
})

const getNewsAndUpdatesByOrganizationFulfilled = (data: Array<NewsUpdates>) => ({
    type: types.GET_NEWS_UPDATES_BY_ORGANIZATION_FULFILLED,
    payload: data
})

const getNewsAndUpdatesByOrganizationRejected = (error: any) => ({
    type: types.GET_NEWS_UPDATES_BY_ORGANIZATION_REJECTED,
    payload: error
})